module.exports = __webpack_public_path__ + "static/media/Star_Play_Logo@3x.eb559305.png";